import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Loader2, MailCheck, XCircle } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

export default function VerifyEmail() {
  const { token } = useParams();
  const { confirmEmail } = useAuth();
  const [state, setState] = useState({ loading: true });
  useEffect(() => {
    confirmEmail(token).then((r) => setState({ loading: false, ok: true, ...r }))
      .catch((e) => setState({ loading: false, ok: false, error: e?.response?.data?.detail || 'This confirmation link is not valid.' }));
    /* eslint-disable-next-line */
  }, [token]);
  return (
    <div className="max-w-lg mx-auto px-4 py-20 text-center" data-testid="verify-email-page">
      {state.loading && <p className="inline-flex items-center gap-2" style={{ color: 'var(--olive)' }}><Loader2 className="animate-spin" size={16} /> Confirming your address…</p>}
      {!state.loading && state.ok && (
        <div className="space-y-3">
          <MailCheck size={40} className="mx-auto" style={{ color: '#1a7f37' }} />
          <h1 className="font-title text-2xl" style={{ color: 'var(--navy)' }} data-testid="verify-email-success">
            {state.already ? 'Already confirmed — thank you' : 'Thank you — your email is confirmed'}
          </h1>
          <p className="text-sm" style={{ color: 'var(--olive)' }}>
            <b>{state.email}</b> is now marked as verified for {state.org}. Renewal notices, newsletters and meeting invitations will keep reaching you here.
          </p>
          <Link to="/" className="inline-block text-sm underline" style={{ color: 'var(--maroon)' }} data-testid="verify-email-home">Back to the website</Link>
        </div>
      )}
      {!state.loading && !state.ok && (
        <div className="space-y-3">
          <XCircle size={40} className="mx-auto" style={{ color: '#8a1f11' }} />
          <h1 className="font-title text-2xl" style={{ color: 'var(--navy)' }} data-testid="verify-email-error">We couldn't confirm that link</h1>
          <p className="text-sm" style={{ color: '#8a1f11' }}>{state.error}</p>
        </div>
      )}
    </div>
  );
}
